import { SelectNextIndexNumberOutputData } from './select-next-index-number-output-data.model';


export class SelectMainMenuNextIndexNumberOutput implements ISelectMainMenuNextIndexNumberOutput {
    status!: number;
    message!: string;
    data!: SelectNextIndexNumberOutputData;

    constructor(data?: ISelectMainMenuNextIndexNumberOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? SelectNextIndexNumberOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectMainMenuNextIndexNumberOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectMainMenuNextIndexNumberOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISelectMainMenuNextIndexNumberOutput {
    status: number;
    message: string;
    data: SelectNextIndexNumberOutputData;
}

